// extracted by mini-css-extract-plugin
export default {"root":"app-react-components-form-components-ReactSelect-module__root"};